import baseAPI from '../services/api-service';

const fetchOrderLink = async ({ orderLinkId }) => {
  const apiService = baseAPI();

  return apiService.get(`order-links/${orderLinkId}`);
};

const saveFile = ({ sessionToken, orderLinkId, file }) => {
  if (!sessionToken) return;

  const apiService = baseAPI(sessionToken);

  return apiService.put(`order-links/${orderLinkId}`, { file });
};

const functions = {
  fetchOrderLink,
  saveFile,
};

export default functions;
